module.exports = __webpack_public_path__ + "img/37200.6f066690.jpg";